import { render, staticRenderFns } from "./StandardList.vue?vue&type=template&id=2d517bef&scoped=true"
import script from "./StandardList.vue?vue&type=script&lang=js"
export * from "./StandardList.vue?vue&type=script&lang=js"
import style0 from "./StandardList.vue?vue&type=style&index=0&id=2d517bef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d517bef",
  null
  
)

export default component.exports